import One from 'src/assets/KnowOurSecrets/brownsimplequotefeedinstagramblog_11zon.avif'
import Two from 'src/assets/KnowOurSecrets/portada-podcast_11zon.avif'
import Tree from 'src/assets/KnowOurSecrets/brownsimplequotefeedinstagramposts_11zon.avif'
import {
    animationVariantsRightSuccess,
    animationVariantsSuccess,
    scaleVariantSuccess,
} from 'src/theme/animations/swipeIn'
import { KnowOurSecretsLabels } from 'src/types'
import { useTranslations } from 'src/provider/LocaleProvider'

export function KnowOurSecretsLabels() {
    const t = useTranslations()
    const KnowOurSecretsContent: KnowOurSecretsLabels[] = [
        {
            id: 1,
            image: One,
            name: 'One',
            link: false,
            animation: animationVariantsRightSuccess,
            ruta: 'blog',
            background: '#C6BDF1',
        },
        {
            id: 2,
            image: Two,
            name: 'Two',
            animation: scaleVariantSuccess,
            link: true,
            linkDirection: `${t('social.spotify')}`,
            background: '#5e018a',
        },
        {
            id: 3,
            image: Tree,
            name: 'Tree',
            animation: animationVariantsSuccess,
            link: true,
            linkDirection: `${t('knowOurSecrets.forms')}`,
            background: '#C8E4FF',
        },
    ]
    return { KnowOurSecretsContent }
}
